module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "proflistcard",
    attrs: {
      "to": _vm.linkParam
    }
  }, [_c('ListCardBadge', {
    attrs: {
      "badges": _vm.badges
    }
  }), _c('AppPicture', {
    attrs: {
      "image": _vm.image,
      "alt": _vm.title
    }
  }), _c('main', {
    staticClass: "proflistcard__main"
  }, [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "center, bold, uppercase"
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1), _c('MoreButton', {
    staticClass: "proflistcard__btn"
  }, [_vm._v("Подробнее")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25cb2c20","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/professions/card/ProfessionListCard.vue
// module id = b5afa50db7f6182ae533
// module chunks = 0